module.exports = __webpack_public_path__ + "static/media/how-step-by-step.32b45e05.png";